import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utilities';
import { mismosDatos } from '../../assets/shared/utility';

const initialState = {
  tiposComprobante: {
    tiposComprobante: [],
    loading: false,
    estaCargado: false,
    error: null
  },
  comprobantes: {
    comprobantes: [],
    loading: false,
    estaCargado: false,
    error: null,
    /** Cuándo llegó la última búsqueda o refresco del listado. */
    actualizadoEl: null
  }
};

//#region load tipos de comprobante
const loadTiposComprobanteStart = (state) => {
  return updateObject(state, {
    tiposComprobante: updateObject(state.tiposComprobante, {
      tiposComprobante: [],
      loading: true,
      estaCargado: false,
      error: null
    })
  });
};

const loadTiposComprobanteSuccess = (state, tiposComprobante) => {
  return updateObject(state, {
    tiposComprobante: updateObject(state.tiposComprobante, {
      tiposComprobante,
      loading: false,
      estaCargado: true
    })
  });
};

const loadTiposComprobanteFail = (state, error) => {
  return updateObject(state, {
    tiposComprobante: updateObject(state.tiposComprobante, {
      loading: false,
      estaCargado: true,
      error
    })
  });
};
//#endregion

//#region load comprobantes
const loadComprobantesStart = (state) => {
  return updateObject(state, {
    comprobantes: updateObject(state.comprobantes, {
      comprobantes: [],
      loading: true,
      estaCargado: false,
      error: null
    })
  });
};

const loadComprobantesSuccess = (state, comprobantes) => {
  return updateObject(state, {
    comprobantes: updateObject(state.comprobantes, {
      comprobantes,
      loading: false,
      estaCargado: true,
      actualizadoEl: new Date()
    })
  });
};

// Como el backend: de la fecha más nueva a la más vieja y, en el día, por número de referencia.
const porFechaDesc = (a, b) => new Date(b.fecha) - new Date(a.fecha) || b.nroReferencia - a.nroReferencia;

/**
 * Refresco del listado sin recargarlo: los que ya están se actualizan (si vienen iguales se deja el mismo objeto)
 * aunque ya no cumplan los estados filtrados, y los nuevos se agregan si los cumplen. No se saca ninguno.
 */
const refrescarComprobantes = (state, recibidos, estados) => {
  const actuales = state.comprobantes.comprobantes;
  const actualizados = actuales.map((actual) => {
    const recibido = recibidos.find((comp) => mismoComprobante(comp, actual));
    return recibido && !mismosDatos(recibido, actual) ? recibido : actual;
  });
  const nuevos = recibidos.filter(
    (recibido) => estados.includes(recibido.estado) && !actuales.some((actual) => mismoComprobante(actual, recibido))
  );
  const cambio = nuevos.length > 0 || actualizados.some((comp, indice) => comp !== actuales[indice]);

  return updateObject(state, {
    comprobantes: updateObject(state.comprobantes, {
      comprobantes: cambio ? [...actualizados, ...nuevos].sort(porFechaDesc) : actuales,
      actualizadoEl: new Date()
    })
  });
};

const loadComprobantesFail = (state, error) => {
  return updateObject(state, {
    comprobantes: updateObject(state.comprobantes, {
      loading: false,
      estaCargado: true,
      error
    })
  });
};
//#endregion

const mismoComprobante = (a, b) =>
  a.idSucursal === b.idSucursal && a.idSistema === b.idSistema && a.idComproba === b.idComproba && a.nroReferencia === b.nroReferencia;

const actualizarUltimaAccion = (state, comprobante, ultimaAccion) => {
  return updateObject(state, {
    comprobantes: updateObject(state.comprobantes, {
      comprobantes: state.comprobantes.comprobantes.map((comp) =>
        mismoComprobante(comp, comprobante) ? updateObject(comp, { ultimaAccion }) : comp
      )
    })
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_TIPOS_COMPROBANTE_IMPRESION_START:
      return loadTiposComprobanteStart(state);
    case actionTypes.LOAD_TIPOS_COMPROBANTE_IMPRESION_SUCCESS:
      return loadTiposComprobanteSuccess(state, action.tiposComprobante);
    case actionTypes.LOAD_TIPOS_COMPROBANTE_IMPRESION_FAIL:
      return loadTiposComprobanteFail(state, action.error);

    case actionTypes.LOAD_COMPROBANTES_IMPRESION_START:
      return loadComprobantesStart(state);
    case actionTypes.LOAD_COMPROBANTES_IMPRESION_SUCCESS:
      return loadComprobantesSuccess(state, action.comprobantes);
    case actionTypes.LOAD_COMPROBANTES_IMPRESION_FAIL:
      return loadComprobantesFail(state, action.error);
    case actionTypes.REFRESCAR_COMPROBANTES_IMPRESION:
      return refrescarComprobantes(state, action.comprobantes, action.estados);

    case actionTypes.ACTUALIZAR_ULTIMA_ACCION_IMPRESION:
      return actualizarUltimaAccion(state, action.comprobante, action.ultimaAccion);

    case actionTypes.CLEAR_IMPRESION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
